var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-layout", { staticClass: "headline" }),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    dark: _vm.addEnable,
                    color: "primary",
                    disabled: !_vm.addEnable
                  },
                  on: {
                    click: function($event) {
                      return _vm.showEditAnnouncemnetDialog({})
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("add")))]
              ),
              _vm._v(" "),
              !_vm.addEnable
                ? _c("v-flex", { attrs: { xs12: "", "text-xs-left": "" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("announcementAddEnable", {
                            announcementsLimit: _vm.announcementsLimit
                          })
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-2 myDense",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.announcements,
                  pagination: _vm.pagination
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "subheading" }, [
                          _vm._v(_vm._s(_vm.toDateString(props.item.startDate)))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "subheading" }, [
                          _vm._v(_vm._s(_vm.toDateString(props.item.endDate)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "subheading annoucemnet-msgContent" },
                          [_vm._v(_vm._s(props.item.msgContent))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          dark: "",
                                          color: "primary",
                                          flat: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showEditAnnouncemnetDialog(
                                              props.item
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("edit")))]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          dark: "",
                                          color: "secondary",
                                          flat: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteAnnouncement(
                                              props.item
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("delete")))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.editAnnouncementDialog
        ? _c("AnnouncementEdit", {
            attrs: {
              title: _vm.title,
              actionFunc: _vm.editAnnouncementFunc,
              announcement: _vm.announcementInEdit
            },
            model: {
              value: _vm.editAnnouncementDialog,
              callback: function($$v) {
                _vm.editAnnouncementDialog = $$v
              },
              expression: "editAnnouncementDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44295dba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44295dba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnnouncementSettings.vue
// module id = null
// module chunks = 